import { EmojiProvider, Emoji } from "react-apple-emojis"
import emojiData from "react-apple-emojis/src/data.json"
import { useEffect, useState } from "react";
import { BP } from "../../../../util/constants/breakpoints";

export default function ProjectDetailsHeader({
    title,
    techStack,
    description,
    emoji,
}){


    const mobileHeaderEmojiWidth = 36;
    const desktopHeaderEmojiWidth = 52;


    const [headerEmojiWidth, setHeaderEmojiWidth] = useState(mobileHeaderEmojiWidth);

    const onWindowWidthChange = () => {
        setHeaderEmojiWidth(getHeaderEmojiWidth())
    }

    const getHeaderEmojiWidth = () => {
        if(window.innerWidth < BP.sm) return mobileHeaderEmojiWidth 
        else return desktopHeaderEmojiWidth 
    }

    useEffect(() => {
        setHeaderEmojiWidth(getHeaderEmojiWidth)
        window.addEventListener("resize", onWindowWidthChange)
        return () => window.removeEventListener("resize", onWindowWidthChange)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return(
        <>
            <div
                className="
                    w-screen

                    pt-28
                    mb-12
                    px-7
                    lg:px-24
                "
            >
                <h1
                    className="
                        flex
                        items-center

                        text-3xl
                        sm:text-5xl
                        tracking-widest
                        font-bold

                        text-body-text-light
                        dark:text-body-text-dark
                    "
                >
                    <EmojiProvider data={emojiData}>
                        <Emoji className="inline" name={emoji} width={headerEmojiWidth}/>
                    </EmojiProvider>
                    &nbsp;
                    {
                        title.toUpperCase()
                    }
                </h1>
                <div
                    className="
                        mt-3
                        sm:mt-5

                        mb-2
                        sm:mb-3
                    "
                >
                    <span
                        className="
                            text-body-text-grey

                            font-semibold
                            tracking-wider
                            text-xs
                            sm:text-base

                        "
                    >
                        {
                            techStack.map((tech) => {
                                if(tech === techStack[techStack.length -1]){
                                    return tech.name
                                }

                                return tech.name + ", "
                            })
                        }
                    </span>
                </div>
                <div>
                    <p
                        className="
                            text-base
                            sm:text-xl
                            text-body-text-grey
                            tracking-wider
                        "
                    >
                        {
                            description
                        }
                    </p>
                </div>
            </div>
        </>
    );
}